import React from 'react';
import { useI18n } from '@/i18n';
import type { LangCode } from '@/i18n/lang';
import './LanguageSwitch.css';

type Props = {
  mode?: 'guest' | 'user';
  className?: string;
};

const LANGS: LangCode[] = ['EN', 'RU', 'UZ'];

const LanguageSwitch: React.FC<Props> = ({ mode = 'guest', className }) => {
  const { language, setLanguage, setUserLanguage, t } = useI18n();

  const onPick = async (lang: LangCode) => {
    if (lang === language) return;
    if (mode === 'user') {
      const ok = await setUserLanguage(lang);
      if (ok) window.location.reload();
      return;
    }
    setLanguage(lang);
    window.location.reload();
  };

  return (
    <div className={`lang-switch ${className || ''}`.trim()}>
      <div className="lang-options">
        {LANGS.map((code) => (
          <button
            key={code}
            type="button"
            className={`lang-option ${language === code ? 'active' : ''}`}
            onClick={() => { void onPick(code); }}
            aria-pressed={language === code}
            aria-label={t(`lang.${code.toLowerCase()}`)}
            title={t(`lang.${code.toLowerCase()}`)}
          >
            {code}
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageSwitch;
